import { BaseUrlService } from './base-url.service';

export class ContractService {
    static $inject: string[] = ['$http', 'BaseUrlService'];

    private baseUrl: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    getContractHtml(user: any) {
        return this.$http.post(this.baseUrl + '/contract/get-html', user);
    }

    getContractPDF(path: any, type: any) {
        return this.$http.get(this.baseUrl + '/contract/get-pdf/' + encodeURIComponent(path) + '/' + encodeURIComponent(type)); // , {responseType: 'arraybuffer'}
    }

    getContractPDFPath(user: any) {
        return this.$http.post(this.baseUrl + '/contract/generate', user);
    }

    signContract(data: any) {
        return this.$http.put(this.baseUrl + '/contract/sign', data);
    }

    sendOTP(data: any) {
        return this.$http.post(this.baseUrl + '/contract/send-otp', data);
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/contract.service.ts